import { parseFromHumanToIsoDate } from './parseFromHumanToIsoDate';

export const toValidDate = (birthDate: string | Date): Date => {
  const formattedDate = typeof birthDate === 'string' ? parseFromHumanToIsoDate(birthDate) : birthDate;

  if (!formattedDate) {
    throw new Error('Invalid date format');
  }

  const date = new Date(formattedDate);

  if (Number.isNaN(date.getTime())) {
    throw new Error('Invalid date format');
  }

  return date;
};
